export var AFFILIATE_BOOKING_STATUS;
(function (AFFILIATE_BOOKING_STATUS) {
    AFFILIATE_BOOKING_STATUS["UNCONFIRMED"] = "unconfirmed";
    AFFILIATE_BOOKING_STATUS["CONFIRMED"] = "confirmed";
})(AFFILIATE_BOOKING_STATUS || (AFFILIATE_BOOKING_STATUS = {}));
//# sourceMappingURL=booking.js.map